import { FINSEMBLECREDENTIALS, safeInteropRegister, toGoLangInvoke } from "../common/windowFunctions";
import uuid from "uuid-random";
import { logStatus } from "../utils";
export class AuthenticationClientImpl {
    constructor(gluePromise, asyncConstructors, loggerClient, Router, storageClient) {
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        this.Router = Router;
        this.storageClient = storageClient;
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "AuthenticationClient",
            method, type, data
        });
    }
    async beginAuthentication(params, cb) {
        this.logStatus("beginAuthentication", "start", params);
        await this.asyncConstructors.ready();
        const handlerName = `FSBL.Clients.AuthenticationClient.beginAuthentication.handler.${uuid()}`;
        this.glue.interop.register(handlerName, safeInteropRegister((err, credentials) => {
            cb?.(err, credentials);
        }));
        const { err, data } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.AuthenticationClient.beginAuthentication", {
            ...params,
            handlerName
        }));
        if (err) {
            this.logStatus("beginAuthentication", "error", err);
        }
        this.logStatus("beginAuthentication", "return", data);
        return { err, data };
    }
    async completeOAUTH(err, params, cb) {
        this.logStatus("completeOAUTH", "start", { err, params });
        await this.asyncConstructors.ready();
        if (!params) {
            params = {};
            const results = window.location.search === "" ? window.location.hash : window.location.search;
            const queryString = new URLSearchParams(results);
            queryString.forEach((value, key) => {
                params[key] = value;
            });
        }
        const { err: err2, data } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.AuthenticationClient.completeOAUTH", {
            err,
            data: params
        }));
        if (err2) {
            this.logStatus("completeOAUTH", "error", err2);
        }
        this.logStatus("completeOAUTH", "return", data);
        return { err: err2, data };
    }
    async getCurrentCredentials(cb) {
        this.logStatus("getCurrentCredentials", "start");
        await this.asyncConstructors.ready();
        const credentials = await this.glue.contexts.get(FINSEMBLECREDENTIALS);
        this.logStatus("getCurrentCredentials", "return", "For security reasons, credentials were not logged.");
        cb?.(null, credentials);
        return {
            err: null,
            data: credentials
        };
    }
    async publishAuthorization(user, credentials) {
        this.logStatus("publishAuthorization", "start", "For security reasons, credentials were not logged.");
        await this.asyncConstructors.ready();
        this.glue.contexts.set(FINSEMBLECREDENTIALS, {
            user,
            credentials
        });
        if (this.glue.windows.my()?.name === "sso-application") {
            const options = {
                user,
                token: credentials?.token ?? null,
                headers: credentials
            };
            this.loggerClient.debug("publishAuthorization() Calling authDone(credentials)");
            globalThis.glue42gd.authDone(options);
            this.Router.publish("AuthorizationState", { state: "done" });
        }
        else {
            this.loggerClient.debug("publishAuthorization", "Called on window other than sso-application. Sending via backChannel.");
            const ssoApplication = this.glue.windows.find("sso-application");
            if (ssoApplication) {
                const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("Finsemble.Clients.AuthenticationClient.publishAuthorization.backChannel", { user, credentials }));
                if (err) {
                    this.loggerClient.error("publishAuthorization error.", err.toString());
                }
            }
            else {
                this.loggerClient.debug("sso-application not running. Skipping backChannel communication.");
                this.loggerClient.debug("Calling StorageClient.setUser");
                this.storageClient.setUser({ user });
            }
        }
        this.logStatus("publishAuthorization", "return");
    }
}
